import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Toolbar } from "../../components/data/Toolbar";
import { DataTable } from "../../components/data/DataTable";
import { listBalances, listWarehouses } from "../../api/warehouse";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { localName } from "../../lib/localName";

// تبويب الأرصدة: الكميات ومتوسط التكلفة والقيمة الإجمالية لكل (مخزن × مادة).
export const WhBalancesTab = ({ branchId, currency }) => {
  const { t, i18n } = useTranslation();
  const [rows, setRows] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!branchId) { setWarehouses([]); return; }
    listWarehouses(branchId).then((d) => setWarehouses(d.items || [])).catch(() => setWarehouses([]));
  }, [branchId]);

  useEffect(() => {
    const id = setTimeout(() => {
      listBalances({ branch_id: branchId || undefined, warehouse_id: warehouseId || undefined,
                     search: search || undefined })
        .then((d) => setRows(d.items || [])).catch(() => setRows([]));
    }, 250);
    return () => clearTimeout(id);
  }, [branchId, warehouseId, search]);

  const num = (n) => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(n || 0);
  const columns = [
    { key: "warehouse", label: t("warehouse.bal.warehouse"),
      render: (r) => <span className="text-xs">
        {localName(warehouses.find((w) => w.warehouse_id === r.warehouse_id), r.warehouse_id)}</span> },
    { key: "item", label: t("warehouse.bal.item"),
      render: (r) => <div><p className="text-xs font-bold">{r.item_name || t("warehouse.bal.unknown")}</p>
        <p className="num font-mono text-[10px] text-muted-foreground">{r.item_code}</p></div> },
    { key: "qty", label: t("warehouse.bal.qty"),
      render: (r) => <span className="num font-mono font-bold">{num(r.qty)} <span className="text-[10px] text-muted-foreground">{r.uom}</span></span> },
    { key: "avg_cost", label: t("warehouse.bal.avgCost"),
      render: (r) => <span className="num font-mono text-xs">{num(r.avg_cost)} {currency}</span> },
    { key: "value", label: t("warehouse.bal.value"),
      render: (r) => <span className="num font-mono text-xs font-bold text-emerald-600">
        {num(r.total_value)} {currency}</span> },
  ];

  return (
    <div className="grid gap-3">
      <Toolbar testid="bal-toolbar" search={search} onSearch={setSearch}
               placeholder={t("warehouse.bal.searchItem")} />
      {warehouses.length > 0 ? (
        <NeuDropdown testid="bal-warehouse" value={warehouseId} onChange={setWarehouseId}
                     placeholder={t("warehouse.bal.allWarehouses")}
                     options={[{ value: "", label: t("warehouse.bal.allWarehouses") },
                               ...warehouses.map((w) => ({ value: w.warehouse_id, label: localName(w) }))]} />
      ) : null}
      <DataTable testid="bal-table" columns={columns} rows={rows}
                 rowKey={(r) => `${r.warehouse_id}-${r.item_id}`}
                 empty={!branchId ? t("warehouse.wh.pickBranch") : t("warehouse.bal.empty")} />
    </div>
  );
};
